
import axios from "axios";
import { getAxiosConfig } from "./axiosConfig";

// Funciones de estudios unificadas en catalogos.ts


export async function traerNombresArchivos({ token, documentoNro, carpeta, urlAxioPP }: { token: string, documentoNro: string, carpeta: number, urlAxioPP: string }) {
  const configAxios = getAxiosConfig(token, urlAxioPP);
  const res = await axios.get(`EstudiosImagenes/TraerNombresArchivos?documentoNro=${documentoNro}&carpeta=${carpeta}`, configAxios);
  return res.data;
}


export async function descargarGaImagenes({ token, documentoNro, nombreArchivo, formato, carpeta, urlAxioPP }: { token: string, documentoNro: string, nombreArchivo: string, formato: string, carpeta: number, urlAxioPP: string }) {
  const configAxios = getAxiosConfig(token, urlAxioPP);
  const res = await axios.request({
    url: `EstudiosImagenes/DescargarImagenes?documentoNro=${documentoNro}&nombreArchivo=${nombreArchivo}&formato=${formato}&carpeta=${carpeta}`,
    method: "GET",
    responseType: "blob",
    ...configAxios,
  });
  return res.data;
}
